import Vue from 'vue';

export default id => (
  new Promise((resolve, reject) => {
    Vue.$http.get(`warehouses/${id}/transactionsV2/types`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/warehouse/transactionTypes.js